module.exports = __webpack_public_path__ + "static/media/news-spmi-care-team-graphic.301b11ee.jpg";